class MattressLayersDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.cacheElements();
      this.waitForStylesheetAndLoad();
      this.attachListeners();
    }
  }

  waitForStylesheetAndLoad() {
    if (document.readyState === 'complete') {
      this.initSwiper();
    } else {
      window.addEventListener('load', () => {
        this.initSwiper();
      });
    }
  }

  cacheElements() {
    this.layerImages = this.querySelectorAll('.MLDImageBlock__Layer');
    this.numberCircles = this.querySelectorAll('.MattressLayersDetails__NumberCircle');
    this.swiperBlockCircles = this.querySelectorAll('.MLDSwiperBlock__NumberCircle');
    this.layerBlockCircles = this.querySelectorAll('.MLDImageBlock__NumberCircle');
  }

  /**
   * Helpful for reinitializing when contents change.
   */
  reinit() {
    this.detachListeners();
    this.cacheElements();
    this.attachListeners();
    this.destroySwiper();
    this.initSwiper();
  }

  attachListeners() {
    // Number cicles update active slide
    this.onCircleClick = this.onCircleClick.bind(this);
    this.numberCircles.forEach(circle => {
      circle.addEventListener('click', this.onCircleClick);
    });
  }

  detachListeners() {
    this.numberCircles.forEach(circle => {
      circle.removeEventListener('click', this.onCircleClick);
    });
  }

  onCircleClick(e) {
    // The index in this element is not zero based
    const index = parseInt(e.currentTarget.dataset.index) - 1;
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  initSwiper() {
    this.swiper = new Swiper('.MLDSwiper.swiper-container', {
      slidesPerView: 1,
      roundLengths: true,
      navigation: {
        nextEl: '.MLDSwiper__Nav .swiper-button-next',
        prevEl: '.MLDSwiper__Nav .swiper-button-prev',
      },
      pagination: {
        el: '.MLDSwiper__Pagination',
        type: 'bullets',
        clickable: true,
      },
      on: {
        slideChange: (swiperInstance) => {
          // Update circles above slides
          this.swiperBlockCircles.forEach(circle => circle.classList.remove('MattressLayersDetails__NumberCircle--active'));
          this.swiperBlockCircles[swiperInstance.activeIndex].classList.add('MattressLayersDetails__NumberCircle--active');

          // Update circles on layer images
          this.layerBlockCircles.forEach(circle => circle.classList.remove('MattressLayersDetails__NumberCircle--active'));
          this.layerBlockCircles[swiperInstance.activeIndex].classList.add('MattressLayersDetails__NumberCircle--active');

          // Update layer image itself
          this.layerImages.forEach(image => image.classList.remove('MLDImageBlock__Layer--selected'));
          this.layerImages[swiperInstance.activeIndex].classList.add('MLDImageBlock__Layer--selected');
        },
      },
      breakpoints: {}
    });
  }

  destroySwiper() {
    this.swiper && this.swiper.destroy();
  }
}

customElements.define('mattress-layers-details', MattressLayersDetails);